import { api } from './api'

export default class AlertaService {
    async getAll(params){
        try {
            let res = await api().get('alerta', {
                params: params
            })
    
            if(res) {
                return res.data
            }
    
            return false
        } catch (error) {
            return false
        }
    }
}